import React from 'react'
import SVG from 'react-inlinesvg'
import cx from 'classnames'
import PropTypes from 'prop-types'

const Icon = ({ size, name, className }) => {
	return (
		<span className={cx('icon', `icon-size-${size}`, className)}>
			<SVG src={name} />
		</span>
	)
}

Icon.propTypes = {
	size: PropTypes.string,
	name: PropTypes.string,
	className: PropTypes.oneOfType([PropTypes.object, PropTypes.string])
}
Icon.dafaultProps = {
	size: '',
	name: ''
}

export default Icon
